module.exports = __webpack_public_path__ + "static/media/comment.08b0fe25.png";